export default "__VITE_ASSET__DmipMymf__"